import React, { useEffect, useRef, useState } from "react";
import { sosContent, SOS_INICIO_ISO } from "../content";
import Form from "./Form";
import { Avatar, IMG, NumerosOficiais, Onda, Pic, Rec, Selos, iniciais, useCountdown } from "./base";

const pad = (n) => String(n).padStart(2, "0");

// ---------------------------------------------------------------- Contagem

/** Faixa "Faltam 00 : 00 : 00 : 00 pro SOS entrar no ar". */
function Contagem() {
  const c = sosContent.contagem;
  const p = useCountdown(SOS_INICIO_ISO);
  const vals = [p ? p.days : 0, p ? p.hours : 0, p ? p.minutes : 0, p ? p.seconds : 0];
  return (
    <div className="sos-contagem">
      <div className="sos-contagem-wrap">
        <span className="sos-contagem-rot">
          <i className="sos-blink" aria-hidden="true" />
          {c.pre}
        </span>
        <ul className="sos-caixas" aria-label="Contagem regressiva">
          {c.unidades.map((u, i) => (
            <li key={u} className="sos-caixa">
              <span className="sos-static" aria-hidden="true" />
              <span className="sos-linhas" aria-hidden="true" />
              <b>{pad(vals[i])}</b>
              <span>{u}</span>
            </li>
          ))}
        </ul>
        <span className="sos-contagem-post">
          {c.post[0]}
          <br />
          {c.post[1]}
        </span>
      </div>
    </div>
  );
}

/** Versão curta "12d 03:14:09" para a barra do celular. */
function ContagemCurta() {
  const p = useCountdown(SOS_INICIO_ISO);
  if (!p) return <b>00d 00:00:00</b>;
  return (
    <b>
      {pad(p.days)}d {pad(p.hours)}:{pad(p.minutes)}:{pad(p.seconds)}
    </b>
  );
}

// ---------------------------------------------------------------- Hero

/** Ordem dos rostos no atalho do hero, como no design. */
const HERO_CONVIDADOS = ["Sandro Curió", "Luma", "Carol Mendonça", "Claudio Hansen", "Deco Duarte", "Marcelão", "Thales Quirino"];

/** Atalho para a dobra Programação, com os rostos dos convidados. */
function AtalhoConvidados({ className }) {
  return (
    <a href="#programacao" className={`sos-hero-convidados ${className}`}>
      <span className="sos-hero-convidados-avs" aria-hidden="true">
        {HERO_CONVIDADOS.map((nome) => (
          <Avatar key={nome} nome={nome} convidado tamanho={36} />
        ))}
      </span>
      <span>
        {sosContent.programacao.heroLink}&nbsp;<em aria-hidden="true">→</em>
      </span>
    </a>
  );
}

const WAVE =
  "M600 363 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0 q15 -18 30 0 q15 18 30 0";

/**
 * Hero: praia ao pôr do sol com estética de TV, logo SOS com a onda de
 * frequência no "O", título, selos, texto e o cartão de inscrição. Depois a
 * faixa amarela e a contagem até 02/11.
 */
export function Hero() {
  const c = sosContent.hero;
  return (
    <header className="sos-hero">
      <div className="sos-hero-kv" aria-hidden="true">
        <Pic src={`${IMG}/hero-kv-praia`} alt="" width={1400} height={788} priority />
      </div>
      <div className="sos-cover sos-hero-blur" aria-hidden="true" />
      <div className="sos-cover sos-hero-sombra" aria-hidden="true" />
      <div className="sos-cover sos-scan" aria-hidden="true" />
      <div className="sos-cover sos-vinheta" aria-hidden="true" />
      <div className="sos-tvroll" aria-hidden="true" />
      <div className="sos-cover sos-hero-esq" aria-hidden="true" />
      <div className="sos-cover sos-hscan" aria-hidden="true" />
      <div className="sos-cover sos-hero-quente" aria-hidden="true" />
      <div className="sos-filmgrain" aria-hidden="true" />

      <div className="sos-hero-wrap">
        <Rec className="sos-rec--hero" />

        <div className="sos-hero-grid">
          <div className="sos-hero-col">
            <img src={`${IMG}/logo-aprova-branca.svg`} alt={c.logoAprovaAlt} width={120} height={20} className="sos-logo-aprova" />

            <div className="sos-logo-wrap sos-float">
              <img src={`${IMG}/logo-sos.svg`} alt={c.logoSosAlt} width={848} height={399} fetchpriority="high" decoding="async" />
              {/* A onda foi desenhada no sistema do logo 3D antigo (viewBox 1753x763,
                  disco do "O" em 842,363 r=122). O <g transform> leva esse sistema
                  para o disco preto do SVG novo (centro 410.7,170.2 r=58.8). */}
              <svg aria-hidden="true" viewBox="0 0 848 399">
                <g transform="translate(410.7 170.2) scale(0.482) translate(-842 -363)">
                  <circle cx="842" cy="363" r="122" fill="#000" />
                  <defs>
                    <clipPath id="sos-freqclip">
                      <circle cx="842" cy="363" r="112" />
                    </clipPath>
                  </defs>
                  <g clipPath="url(#sos-freqclip)">
                    <g className="sos-freq">
                      <path d={WAVE} fill="none" stroke="#fff" strokeOpacity="0.3" strokeWidth="7" strokeLinecap="round" />
                    </g>
                    <Onda />
                  </g>
                </g>
              </svg>
            </div>

            <h1>
              {c.h1.pre}
              <em>{c.h1.hl}</em>
            </h1>
            <Selos />
            <p className="sos-hero-texto">
              {c.paragrafo.pre}
              <strong>{c.paragrafo.b}</strong>
              {c.paragrafo.post}
            </p>
            <AtalhoConvidados className="sos-so-desktop" />
          </div>

          <div id="inscricao" className="sos-form-card">
            <span className="sos-form-tag">{sosContent.form.tag}</span>
            <Form />
          </div>
          {/* No celular o atalho vem depois do formulário. */}
          <AtalhoConvidados className="sos-so-mobile" />
        </div>
      </div>

      <div className="sos-ticker" aria-hidden="true">
        <div className="sos-ticker-trilho">
          {Array.from({ length: 6 }, (_, k) =>
            sosContent.ticker.map((t) => (
              <span key={`${k}-${t}`}>
                {t}
                <i />
              </span>
            ))
          )}
        </div>
      </div>

      <Contagem />
    </header>
  );
}

// ---------------------------------------------------------------- Benefícios

/** "Muito mais que uma simples revisão", 6 benefícios e o card fixo do professor. */
export function Beneficios() {
  const c = sosContent.beneficios;
  return (
    <section className="sos-sec sos-benef" aria-labelledby="sos-benef-h2">
      <div className="sos-benef-col">
        <div className="sos-benef-head sos-reveal">
          <h2 id="sos-benef-h2">
            {c.h2}
            <img src={`${IMG}/kv/revisao.svg`} alt="" aria-hidden="true" width={46} height={46} className="sos-boil" style={{ "--rot": "-10deg" }} />
          </h2>
          <p className="sos-benef-lead">
            {c.lead.pre}
            <strong>{c.lead.b}</strong>
            {c.lead.post}
          </p>
        </div>
        <span className="sos-benef-sub">{c.sub}</span>
        <ul className="sos-vidro sos-perks">
          {c.itens.map((p) => (
            <li key={p.label} className="sos-perk sos-reveal">
              <i aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFF00" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d={p.icon} />
                </svg>
              </i>
              {p.label}
            </li>
          ))}
        </ul>
      </div>

      <div className="sos-side-col">
        <div id="side-card" className="sos-side">
          <div className="sos-side-foto">
            <Pic src={`${IMG}/ref-prof-praia`} alt={c.card.fotoAlt} width={1600} height={900} />
            <div className="sos-cover sos-scan" aria-hidden="true" />
            <div className="sos-cover sos-vinheta" aria-hidden="true" />
            <div className="sos-tvroll sos-tvroll--forte" aria-hidden="true" />
            <div className="sos-cover sos-tvflick" aria-hidden="true" />
            <div className="sos-cover sos-side-fade" aria-hidden="true" />
            <Rec />
          </div>
          <div className="sos-side-body">
            <Selos pequeno />
            <span className="sos-side-titulo">{c.card.titulo}</span>
            <a href="#inscricao" className="sos-btn">
              {c.card.cta}&nbsp;→
            </a>
            <p className="sos-side-rodape">{c.card.rodape}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

// ---------------------------------------------------------------- Programação

/** Uma linha da grade: horário, avatar(es) e professor + disciplina. "Alan e Dudu" vira dois avatares. */
function Linha({ aula }) {
  const [hora, prof, disciplina, convidado] = aula;
  return (
    <li className={`sos-aula${convidado ? " sos-aula--convidado" : ""}`}>
      <span className="sos-aula-hora">{hora}</span>
      <span className="sos-aula-avs" aria-hidden="true">
        {prof.split(" e ").map((n) => (
          <Avatar key={n} nome={n} convidado={!!convidado} />
        ))}
      </span>
      <span className="sos-aula-txt">
        <b>{prof}</b>
        <span>{disciplina}</span>
      </span>
    </li>
  );
}

/**
 * Grade das duas semanas. No desktop as três colunas (SEG/TER/QUA) e o Sábado
 * especial aparecem juntos; no celular a barra de dias escolhe uma coluna só
 * (quem esconde é o CSS, por classe).
 */
function ProgramacaoGrade() {
  const c = sosContent.programacao;
  const [semana, setSemana] = useState(0);
  const [dia, setDia] = useState(0);
  const s = c.semanas[semana];
  const sabado = s.dias[3];

  return (
    <div className="sos-prog-painel">
      <div className="sos-prog-semanas" role="tablist" aria-label="Semana">
        {c.semanas.map((w, i) => (
          <button
            key={w.num}
            type="button"
            role="tab"
            aria-selected={i === semana}
            className={i === semana ? "on" : undefined}
            onClick={() => {
              setSemana(i);
              setDia(0);
            }}
          >
            <span>{w.num}</span>
            {w.curto}
          </button>
        ))}
      </div>

      <div className="sos-prog-corpo" role="tabpanel" aria-label={`${s.num}: ${s.curto}`}>
        <div className="sos-prog-dias" role="tablist" aria-label="Dia">
          {s.dias.map((d, i) => (
            <button key={d.data} type="button" role="tab" aria-selected={i === dia} className={i === dia ? "on" : undefined} onClick={() => setDia(i)}>
              <span>{d.dow}</span>
              {d.data}
            </button>
          ))}
        </div>

        <div className="sos-prog-cols">
          {s.dias.slice(0, 3).map((d, i) => (
            <section key={d.data} className={`sos-prog-col${i === dia ? " on" : ""}`} aria-label={`${d.dow} ${d.data}`}>
              <header>
                <span>{d.dow}</span>
                <b>{d.data}</b>
              </header>
              <ul>
                {d.aulas.map((a) => (
                  <Linha key={`${a[0]}-${a[1]}`} aula={a} />
                ))}
              </ul>
            </section>
          ))}
        </div>

        <section className={`sos-prog-sab${dia === 3 ? " on" : ""}`} aria-label={`Sábado especial, ${sabado.data}`}>
          <header>
            <span className="sos-prog-pill">
              <i className="sos-blink" aria-hidden="true" />
              {c.sabadoSelo}
            </span>
            <b>{sabado.data}</b>
            <span className="sos-prog-sab-txt">{c.sabadoTexto}</span>
          </header>
          <ul>
            {sabado.aulas.map((a) => (
              <Linha key={`${a[0]}-${a[1]}`} aula={a} />
            ))}
          </ul>
        </section>

        <section className="sos-prog-sims" aria-label={c.simuladosSelo}>
          <span className="sos-prog-pill sos-prog-pill--ceu">{c.simuladosSelo}</span>
          <ul>
            {s.simulados.map((m) => (
              <li key={m.area}>
                <i aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1B229F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2 M9 14l2 2 4-4" />
                  </svg>
                </i>
                <span>
                  <b>Simulado de {m.area}</b>
                  <span>
                    Libera {m.abre} às 00h · até {m.fecha}
                  </span>
                </span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}

/** Título com o adesivo da TV, participações especiais, a grade e o CTA com a capivara. */
export function Programacao() {
  const c = sosContent.programacao;
  return (
    <section id="programacao" className="sos-sec sos-prog" aria-labelledby="sos-prog-h2">
      <div className="sos-prog-head sos-reveal">
        <h2 id="sos-prog-h2">
          {/* "pré-Enem" não quebra no hífen. */}
          {c.h2.split("pré-Enem").map((parte, i) => (
            <span key={i}>
              {i > 0 && <span className="sos-nowrap">pré-Enem</span>}
              {parte}
            </span>
          ))}
          <img src={`${IMG}/kv/tv.svg`} alt="" aria-hidden="true" width={48} height={48} className="sos-boil sos-prog-tv" style={{ "--rot": "-6deg" }} />
        </h2>
        <p>{c.sub}</p>
      </div>

      <div className="sos-prog-bloco">
        <h3 className="sos-prog-titulo">{c.convidadosTitulo}</h3>
        <ul className="sos-convidados">
          {c.convidados.map((g, i) => (
            <li key={g.nome} className="sos-convidado sos-reveal">
              <div className="sos-convidado-foto">
                {g.foto ? (
                  <Pic src={`${IMG}/profs/${g.foto}`} alt={g.nome} width={560} height={560} />
                ) : (
                  <span className="sos-convidado-ini" aria-hidden="true">
                    {iniciais(g.nome)}
                  </span>
                )}
                <div className="sos-cover sos-scan" aria-hidden="true" />
                <div className="sos-cover sos-vinheta" aria-hidden="true" />
                {/* Cada card com duração e atraso próprios, para os efeitos não andarem juntos. */}
                <div className="sos-tvroll sos-tvroll--forte" aria-hidden="true" style={{ animationDuration: `${4200 + i * 260}ms`, animationDelay: `${i * 380}ms` }} />
                <div className="sos-cover sos-tvflick" aria-hidden="true" style={{ animationDuration: `${3600 + i * 410}ms` }} />
              </div>
              <div className="sos-convidado-corpo">
                <span className="sos-convidado-selo">
                  <i aria-hidden="true" />
                  {g.selo}
                </span>
                <b>{g.nome}</b>
                <span className="sos-convidado-disc">{g.disciplina}</span>
                <em>{g.frase}</em>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="sos-prog-bloco sos-reveal">
        <h3 className="sos-prog-titulo">{c.gradeTitulo}</h3>
        <ProgramacaoGrade />
      </div>

      <div className="sos-prog-cta sos-reveal">
        <Pic src={`${IMG}/capivara-joinha`} alt={c.cta.capivaraAlt} width={340} height={511} className="sos-prog-capivara sos-float" />
        <div className="sos-prog-cta-txt">
          <p>{c.cta.texto}</p>
          <a href={c.cta.href} className="sos-btn">
            {c.cta.botao}&nbsp;→
          </a>
        </div>
      </div>
    </section>
  );
}

// ---------------------------------------------------------------- Prova social

/**
 * Carrossel de 22 prints: 3 visíveis no desktop, 1 abaixo de 960px. Autoplay de
 * 5 s, pausa no hover, swipe no celular e "troca de canal" ao mudar de slide.
 */
export function ProvaSocial() {
  const c = sosContent.provaSocial;
  const N = c.slides.length;
  const mod = (i) => ((i % N) + N) % N;
  const [idx, setIdx] = useState(0);
  const [pausa, setPausa] = useState(false);
  const tx = useRef(0);
  const secao = useRef(null);
  const primeiro = useRef(true);

  useEffect(() => {
    if (primeiro.current) {
      primeiro.current = false;
      return;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !secao.current) return;
    secao.current.querySelectorAll(".sos-zap").forEach((el) => {
      el.animate(
        [
          { opacity: 1, backgroundPosition: "0 0, 0 0, 0 0" },
          { opacity: 0.95, backgroundPosition: "0 -14px, -40px 30px, 0 0", offset: 0.25 },
          { opacity: 0.85, backgroundPosition: "0 9px, 60px -50px, 0 0", offset: 0.5 },
          { opacity: 0.4, backgroundPosition: "0 -5px, -20px 70px, 0 0", offset: 0.75 },
          { opacity: 0 },
        ],
        { duration: 380, easing: "steps(6)" }
      );
      const img = el.parentElement && el.parentElement.querySelector("img");
      if (img)
        img.animate(
          [
            { transform: "scaleY(0.02) scaleX(1.2)", filter: "brightness(3)" },
            { transform: "scaleY(1.04) scaleX(0.98)", filter: "brightness(1.3)", offset: 0.5 },
            { transform: "none", filter: "none" },
          ],
          { duration: 420, easing: "cubic-bezier(0.2,0.7,0.2,1)" }
        );
    });
  }, [idx]);

  useEffect(() => {
    if (pausa) return;
    const id = window.setInterval(() => {
      if (!document.hidden) setIdx((i) => (i + 1) % N);
    }, 5000);
    return () => window.clearInterval(id);
  }, [pausa, N]);

  const slide = (off) => {
    const [nome, w, h] = c.slides[mod(idx + off)];
    const centro = off === 0;
    return (
      <div key={`${off}-${nome}`} className={`sos-slide ${centro ? "sos-slide--centro" : "sos-slide-lat"}`} aria-hidden={!centro}>
        <div className="sos-slide-moldura">
          <div className="sos-slide-tela">
            <Pic src={`${IMG}/${nome}`} alt={centro ? c.imgAlt : ""} width={w} height={h} />
            <div className="sos-cover" aria-hidden="true" />
            <div className="sos-zap" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <section ref={secao} className="sos-prova" aria-labelledby="sos-prova-h2">
      <div className="sos-cover sos-prova-calcadao" aria-hidden="true" />
      <div className="sos-onda sos-onda--topo" aria-hidden="true" />
      <div className="sos-onda sos-onda--base" aria-hidden="true" />
      <div className="sos-prova-wrap">
        <h2 id="sos-prova-h2" className="sos-reveal">
          {c.h2}
          <img src={`${IMG}/kv/aspas.svg`} alt="" aria-hidden="true" width={46} height={46} className="sos-boil" style={{ "--rot": "8deg" }} />
        </h2>

        <div
          className="sos-carrossel"
          onMouseEnter={() => setPausa(true)}
          onMouseLeave={() => setPausa(false)}
          onTouchStart={(e) => {
            tx.current = e.touches[0].clientX;
            setPausa(true);
          }}
          onTouchEnd={(e) => {
            const dx = e.changedTouches[0].clientX - tx.current;
            if (Math.abs(dx) > 40) setIdx((i) => mod(i + (dx < 0 ? 1 : -1)));
            setPausa(false);
          }}
        >
          <button type="button" className="sos-seta" aria-label={c.anterior} onClick={() => setIdx((i) => mod(i - 1))}>
            ←
          </button>
          <div className="sos-slides">
            {slide(-1)}
            {slide(0)}
            {slide(1)}
          </div>
          <button type="button" className="sos-seta" aria-label={c.proximo} onClick={() => setIdx((i) => mod(i + 1))}>
            →
          </button>
        </div>

        <div className="sos-dots-wrap">
          <div className="sos-dots">
            {c.slides.map((s, i) => (
              <button key={s[0]} type="button" className="sos-dot" aria-label={`${c.irPara} ${i + 1}`} aria-current={i === idx} onClick={() => setIdx(i)} />
            ))}
          </div>
          <span className="sos-contador">
            {String(idx + 1).padStart(2, "0")} / {N}
          </span>
        </div>

        <ul className="sos-vidro sos-numeros sos-reveal">
          {c.numeros.map((n) => (
            <li key={n.label}>
              <b>{n.valor}</b>
              <span>{n.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

// ---------------------------------------------------------------- FAQ + rodapé

/** FAQ com <details name="sos-faq"> (um aberto por vez), título fixo no desktop e rodapé. */
export function Faq() {
  const c = sosContent.faq;
  const r = sosContent.rodape;
  return (
    <section className="sos-sec sos-faq" aria-labelledby="sos-faq-h2">
      <div className="sos-faq-ondas" aria-hidden="true" />
      <div className="sos-faq-head sos-reveal">
        <h2 id="sos-faq-h2">
          {c.h2}
          <img src={`${IMG}/kv/interrogacao.svg`} alt="" aria-hidden="true" width={34} height={34} className="sos-boil sos-boil--peq" style={{ "--rot": "-6deg" }} />
        </h2>
      </div>
      <div className="sos-faq-lista">
        {c.itens.map((it, i) => (
          <details key={it.q} className="sos-faq-item" name="sos-faq" open={i === 0}>
            <summary>
              <span>{it.q}</span>
              <span className="sos-faq-icone" aria-hidden="true" />
            </summary>
            <p>{it.a}</p>
          </details>
        ))}
      </div>
      <div className="sos-rodape">
        <img src={`${IMG}/logo-aprova-branca.svg`} alt={r.logoAlt} width={144} height={24} />
        <span>{r.tagline}</span>
        <NumerosOficiais margemTopo={16} />
      </div>
    </section>
  );
}

// ---------------------------------------------------------------- Barra do celular

/** Barra fixa do celular: aparece só depois que o formulário ficou para trás. */
export function BarraMobile() {
  const c = sosContent.barra;
  const [mostra, setMostra] = useState(false);
  useEffect(() => {
    const form = document.getElementById("inscricao");
    if (!form) return;
    const obs = new IntersectionObserver(([e]) => {
      setMostra(!e.isIntersecting && e.boundingClientRect.top < 0);
    });
    obs.observe(form);
    return () => obs.disconnect();
  }, []);
  return (
    <div className="sos-barra" data-visivel={mostra ? "true" : "false"} aria-hidden={!mostra}>
      <div className="sos-barra-txt">
        <small>{c.pre}</small>
        <ContagemCurta />
      </div>
      <a href={c.href} className="sos-btn">
        {c.cta}&nbsp;→
      </a>
    </div>
  );
}
